import styled from 'styled-components';
import {StyledButton} from "../../../components/Buttons/DefaultButton/DefaultButton.styles";


export const Page = styled.div`
    height: 100%;
    width: 100%;
    overflow: auto;
`
export const Container = styled.div`
    padding: 0 1rem 0 1rem;
    overflow: auto;
    display: flex;
    flex-direction: column;
    background-color: val(--primary-contrast);
    align-items: start;
    @media (min-width: 768px) {
        padding: 0;
    }
    

  .inset {
    margin: 0 0 1rem;
    font-size:13px;
  }

  .halfWidth {
    max-width: 50%;
  }
`

export const ButtonContainer = styled.div`
  margin: auto;
  padding-bottom: 2rem;
`

export const ContinueButton = styled(StyledButton)`
    min-width: 20rem;
    max-width: 24rem;
    align-self: center;

    @media only screen and (min-width: 900px) {
        margin-top: 2rem !important;
    }
    `
